import _DialogTitle from "@mui/material/DialogTitle";
import _Dialog from "@mui/material/Dialog";
import _DialogContent from "@mui/material/DialogContent";
import _Typography from "@mui/material/Typography";
import _Close from "@mui/icons-material/Close";
import _ChevronRight from "@mui/icons-material/ChevronRight";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _ChevronLeft from "@mui/icons-material/ChevronLeft";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
export function PhotosDialog({
  initialIndex = 0,
  photos,
  onClose,
  ...props
}) {
  const [selectedIndex, selectIndex] = useState(initialIndex);

  // seule l'ouverture repositionne la visionneuse : sinon elle sauterait a chaque navigation
  useEffect(() => {
    if (props.open) selectIndex(initialIndex);
  }, [props.open]);
  function handlePrev() {
    if (!photos) return;
    const size = photos.length;
    selectIndex(index => ((index - 1) % size + size) % size);
  }
  function handleNext() {
    if (!photos) return;
    const size = photos.length;
    selectIndex(index => (index + 1) % size);
  }
  useEffect(() => {
    if (!props.open || !photos || photos.length < 2) return;
    function handleKeyDown(event) {
      if (event.key === 'ArrowLeft') handlePrev();else if (event.key === 'ArrowRight') handleNext();
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [props.open, photos]);
  const photo = photos?.[selectedIndex];
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose(),
    slotProps: {
      paper: {
        sx: {
          borderRadius: 4
        }
      }
    }
  }, props), photo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement("img", {
    alt: photo.title || '',
    src: photo.url || ''
  }), photos && photos.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrevButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.photos_dialog.actions.prev"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: handlePrev,
    size: "small"
  }, /*#__PURE__*/React.createElement(_ChevronLeft, null)))), /*#__PURE__*/React.createElement(NextButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.photos_dialog.actions.next"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: handleNext,
    size: "small"
  }, /*#__PURE__*/React.createElement(_ChevronRight, null)))))), /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), photo.title && /*#__PURE__*/React.createElement(StyledDialogTitle, null, photo.title), (photo.copyright || photo.description) && /*#__PURE__*/React.createElement(_DialogContent, null, photo.copyright && /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, "\xA9 ", photo.copyright), photo.description && /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, photo.description))));
}
const StyledDialogTitle = styled(_DialogTitle)`
  padding-right: 46px;
`;
const CloseButtonWrapper = styled.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const ImageWrapper = styled.div`
  position: relative;

  img {
    display: block;
    width: 100%;
  }
`;
const NavButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const PrevButtonWrapper = styled(NavButtonWrapper)`
  left: 8px;
`;
const NextButtonWrapper = styled(NavButtonWrapper)`
  right: 8px;
`;